'use client';
import Script from 'next/script';

const LoqateAddress = () => {
  return (
    <>
      <link rel="stylesheet" href="/react/css/loqateAddress/address-3.70.css" />
      <Script
        src="/react/scripts/loqateAddress/address-3.70.js"
        type="text/javascript"
        async
      />
    </>
  );
};
export default LoqateAddress;
